import { memo, useState } from 'react'
import styled from 'styled-components'

/**
 * A token's picture, or its first letter.
 *
 * The board's own mark rather than the app's CurrencyIcon: that one carries a
 * link, two popovers and a route with it, and reads the terminal's theme
 * tokens — which resolve to the light theme on these screens, the trap that
 * turned the no-logo initial black on black. The rule for the letter is the
 * same one the app's fallback learned: letters and digits only, the first one,
 * upper case.
 */
export const TokenMark: React.FC<{
  src: string | undefined
  ticker: string
  size?: number
}> = memo(({ src, ticker, size = 26 }) => {
  const [broken, setBroken] = useState(false)
  const letters = ticker.replaceAll(/[^\p{Letter}\p{Number}]/gu, '')
  const initial = (letters || ticker || '?').slice(0, 1).toUpperCase()

  return (
    <Mark style={{ width: size, height: size, borderRadius: size * 0.28 }}>
      {src && !broken ? (
        <img src={src} alt="" onError={() => setBroken(true)} />
      ) : (
        <b style={{ fontSize: size * 0.46 }}>{initial}</b>
      )}
    </Mark>
  )
})

const Mark = styled.span`
  position: relative;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: var(--chip);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  b {
    font-weight: 600;
    letter-spacing: -0.3px;
    color: var(--t2);
  }
`
